import IO from 'socket.io-client'

const socket = IO(process.env.REACT_APP_SOCKET_URL, {
  transports: ['websocket', 'polling'],
  query: { token: localStorage.getItem('access_token') },
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
})

export default socket
